import {
  IntegrationRedirectStatuses,
  IntegrationRedirectStatusesType,
} from '@linqpal/models/src/dictionaries'
import { useCallback } from 'react'

export const useHandleAchCardPaymentSuccess = (
  onRedirectBack: (status: IntegrationRedirectStatusesType) => Promise<void>,
) => {
  return useCallback(async () => {
    try {
      await onRedirectBack(IntegrationRedirectStatuses.PaymentProcessing)
    } catch (err) {
      console.error('Error handling ACH card payment success:', err)
    }
  }, [onRedirectBack])
}

export const useHandleBtcPaymentSuccess = (
  onRedirectBack: (status: IntegrationRedirectStatusesType) => Promise<void>,
) => {
  return useCallback(async () => {
    try {
      await onRedirectBack(IntegrationRedirectStatuses.InReview)
    } catch (err) {
      console.error('Error handling BTC payment success:', err)
    }
  }, [onRedirectBack])
}

export const useHandlePaymentFailure = (
  onRedirectBack: (status: IntegrationRedirectStatusesType) => Promise<void>,
) => {
  return useCallback(async () => {
    try {
      await onRedirectBack(IntegrationRedirectStatuses.SomethingWentWrong)
    } catch (err) {
      console.error('Error handling payment failure:', err)
    }
  }, [onRedirectBack])
}
